import React from 'react';
import Button from "../../../components/ui/button/button";
import {withRouter} from "../../../layouts/AdminLayout/AdminLayout";
import {ReactComponent as PlusIcon} from "../../../images/icons/ui/plus-icon.svg";
import TextField from "../../../components/TextField/TextField";
import {ReactComponent as OrderUpIcon} from "../../../images/icons/ui/order-up.svg";
import {ReactComponent as OrderDownIcon} from "../../../images/icons/ui/order-down.svg";
import {ReactComponent as TrashIcon} from "../../../images/icons/ui/trash-icon.svg";
import RadioSlider from "../../../components/ui/radioSlider/radioSlider";
import ImageUploader from "../../../components/ui/imageUploader/imageUploader";
import API from "../../../components/api";
import {SERVER_URL} from "../../../config";


class AdminPanelVacanciesPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],

            tabValues: [
                {name: 'Prodoctorov', value: 'prodoctorov'},
                {name: 'Другое', value: 'other',},
                {name: 'Нет', value: 'no'},
            ],
        }

        this.changeItem = (name, index, value) => {
            let {items} = this.state;

            items[index][value] = name

            this.setState({
                items: [...items]
            });
        }

        this.addItem = () => {
            const {items} = this.state;

            let item = {
                id: -Math.random(),
                name: '',
                url: '',
            }

            this.setState({
                items: [item, ...items]
            });
        }

        this.updateItems = () =>{
            API.adminGetVacancies()
                .then(data => this.setState({items: data}))
                .catch(error => {
                })
        }

        this.saveItems = (items) => {
            API.adminSaveVacancies(items)
                .then(data => {
                    this.props.addSnackbar("Вакансии успешно сохранены", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateItems()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось сохранить вакансии", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.swapItem = (itemId, side) => {
            const {items} = this.state;

            const index = items.findIndex(c => c.id === itemId);
            if (index === -1) return;

            const targetIndex =
                side === 'up'
                    ? index - 1
                    : side === 'down'
                        ? index + 1
                        : index;

            if (targetIndex < 0 || targetIndex >= items.length) {
                return;
            }

            const current = items[index];
            items[index] = items[targetIndex];
            items[targetIndex] = current;

            this.setState({items: items})
        }

        this.deleteItem = (itemId) => {
            this.setState(prevState => {
                const items = prevState.items;
                const newItems = items.filter(s => s.id !== itemId);

                return {
                    items: newItems
                };
            });
        };
    }

    componentDidMount() {
        this.updateItems()
    }

    render() {
        return <div className='admin-page-container'>
            <div className='header'>
                <div className='title'>
                    Вакансии
                </div>
                <div className='controls'>
                    <Button type='accent' size='medium' onClick={() => {
                        this.saveItems(this.state.items)
                    }}>
                        Сохранить изменения
                    </Button>
                    <Button type='primary' size='medium'
                            onClick={() => {
                                this.updateItems()
                            }}>
                        Отменить
                    </Button>
                </div>
            </div>
            <div className='content'>
                <Button type='transparent' size='large' fullWidth
                        startIcon={<PlusIcon/>}
                        onClick={() => {
                            this.addItem()
                        }}>
                    Добавить
                </Button>
                <div className='items'>
                    {
                        this.state.items.map((item, index) => {
                            return <div key={item.id} className='item'>
                                <div className='top'>
                                    <TextField label='Название вакансии' fullWidth
                                               value={this.state.items[index].name}
                                               onChange={(e) => this.changeItem(e.target.value, index, 'name')}/>
                                    <div className='button-group'>
                                        <div className='buttons'>
                                            <div className='divider'/>
                                            <Button customClass='icon-size-24' type='secondary' size='medium' fullWidth
                                                    startIcon={<OrderUpIcon/>}
                                                    onClick={() => this.swapItem(item.id, 'up')}/>
                                            <Button customClass='icon-size-24' type='secondary' size='medium' fullWidth
                                                    startIcon={<OrderDownIcon/>}
                                                    onClick={() => this.swapItem(item.id, 'down')}/>
                                            <div className='divider'/>
                                            <Button type='primary' size='medium' fullWidth
                                                    startIcon={<TrashIcon/>}
                                                    onClick={() => this.deleteItem(item.id)}/>
                                        </div>
                                    </div>
                                </div>
                                <TextField label='Ссылка' fullWidth
                                           value={this.state.items[index].url}
                                           onChange={(e) => this.changeItem(e.target.value, index, 'url')}/>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    }
}


export default withRouter(AdminPanelVacanciesPage);
